/**
 * User-facing names for content sections. Change these to rebrand (e.g. Thoughts → Notes)
 * without renaming internal `kind` values or frontmatter fields.
 */
export const contentLabels = {
  siteTitle: 'BaldyDev Blog',
  siteTagline: 'Writing and short updates on development and technology',
  longFormSection: 'Writing',
  shortFormSection: 'Thoughts',
  longFormLinkDefault: 'Read the full post',
} as const;
